var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.064 14.081H7.249a.334.334 0 01-.22-.584L18.545 3.364A1.92 1.92 0 0016.012.481L1.104 13.6a3.2 3.2 0 000 4.8l14.905 13.116a1.92 1.92 0 002.533-2.881L7.026 18.502a.335.335 0 01.22-.584h22.817a1.92 1.92 0 000-3.839z"
  })));
}
export default SvgArrowLeft1;